/*******************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2022 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ******************************************************************************/

export default function selectAvatarForSize(
  images: Record<string, string>,
  targetSize: number
): string {
  const imageSizes = Object.keys(images).map((size) => parseInt(size));
  imageSizes.sort();
  const targetImageSizeMatch = imageSizes.find(
    (imageSize) => imageSize >= targetSize
  );
  const defaultedImageSize = targetImageSizeMatch ?? imageSizes[0];
  return images[defaultedImageSize];
}
